import { createSlice } from "@reduxjs/toolkit";

export const cashPaymentSlice = createSlice({
  name: "cashPayment",
  initialState: {
    error: "Sorry! No Data Found.",
    message: null,
    loading: false,
    list: [],
    model: false,
    drawer: false,
    error_msg: null,
    listCount: 0,
    rowdata: {
      items: [
        { cashpayment_account: "", amount: "", reference: "", remarks: "", vehicle_no: "", ref_post_doc_no: "", qty: 0, vehicle_number: "" },
      ],
      deletedItems: [],
    },
    params: {
      start_date: "",
      end_date: "",
      no_of_pages: 0,
      page_size: 10,
      page: 1,
      search: "",
      currentSort: "code",
      sortOrder: "-",
    },
  },

  reducers: {
    getCashPayments: (state) => {
      return { ...state, loading: true };
    },
    cashPaymentListSuccessful: (state, action) => {
      var noofpages = Math.ceil(
        action.payload.response.count / state.params.page_size
      );
      return {
        ...state,
        listCount: action.payload.response.count,
        list: action.payload.response.results,
        loading: false,
        params: { ...state.params, no_of_pages: noofpages },
      };
    },
    cashPaymentAdd: (state) => {
      return { ...state, loading: true };
    },
    cashPaymentAddSuccessful: (state) => {
      return {
        ...state,
        loading: false,
        model: false,
        rowdata: {
          items: [
            { cashpayment_account: "", amount: "", reference: "", remarks: "", vehicle_no: "", ref_post_doc_no: "", qty: 0, vehicle_number: "" },
          ],
          deletedItems: [],
        },
      };
    },
    getCashPaymentById: (state) => {
      return { ...state, loading: true };
    },
    cashPaymentByIdSuccessful: (state, action) => {
      const apiItems = action.payload.cashpaymentitems || [];
      const items = apiItems.length
        ? apiItems.map((item) => ({
            ...item,
            cashpayment_account: item.cashpayment_account?.id || item.cashpayment_account || item.account || "",
            vehicle_no: item.vehicle_no?.id || item.vehicle_no || "",
          }))
        : [{ cashpayment_account: "", amount: "", reference: "", remarks: "", vehicle_no: "", ref_post_doc_no: "", qty: 0 }];
      return {
        ...state,
        loading: false,
        rowdata: {
          id: action.payload.id,
          doc_no: action.payload.code,
          date: action.payload.date,
          counter_id: action.payload.counter?.id,
          cash_bank_ac: action.payload.cash_bank_ac,
          division_id: action.payload.division?.id,
          firm_company: action.payload.firm_company,
          state_id: action.payload.state?.id,
          narration: action.payload.narration,
          attachment: action.payload.attachment,
          items,
          deletedItems: [],
        },
      };
    },
    cashPaymentEdit: (state, action) => {
      const apiItems = action.payload.cashpaymentitems || [];
      const items = apiItems.length
        ? apiItems.map((item) => ({
            ...item,
            cashpayment_account: item.cashpayment_account?.id || item.cashpayment_account || item.account || "",
            vehicle_no: item.vehicle_no?.id || item.vehicle_no || "",
          }))
        : [{ cashpayment_account: "", amount: "", reference: "", remarks: "", vehicle_no: "", ref_post_doc_no: "", qty: 0 }];
      return {
        ...state,
        model: true,
        rowdata: {
          id: action.payload.id,
          doc_no: action.payload.code,
          date: action.payload.date,
          counter_id: action.payload.counter?.id,
          cash_bank_ac: action.payload.cash_bank_ac,
          division_id: action.payload.division?.id,
          firm_company: action.payload.firm_company,
          state_id: action.payload.state?.id,
          narration: action.payload.narration,
          attachment: action.payload.attachment,
          items,
          deletedItems: [],
        },
      };
    },
    cashPaymentDelete: (state) => {
      return { ...state, loading: false };
    },
    InputChangeValue: (state, action) => {
      return {
        ...state,
        rowdata: {
          ...state.rowdata,
          [action.payload.key]: action.payload.value,
        },
      };
    },
    ItemInputChangeValue: (state, action) => {
      const { index, key, value } = action.payload;
      const items = [...state.rowdata.items];
      items[index] = { ...items[index], [key]: value };
      return {
        ...state,
        rowdata: { ...state.rowdata, items },
      };
    },
    addItemRow: (state) => {
      return {
        ...state,
        rowdata: {
          ...state.rowdata,
          items: [
            ...state.rowdata.items,
            { cashpayment_account: "", amount: "", reference: "", remarks: "", vehicle_no: "", ref_post_doc_no: "", qty: 0, vehicle_number: "" },
          ],
        },
      };
    },
    removeItemRow: (state, action) => {
      const removedItem = state.rowdata.items[action.payload];
      const items = state.rowdata.items.filter((_, i) => i !== action.payload);
      const deletedItems = [...(state.rowdata.deletedItems || [])];
      if (removedItem?.id) {
        deletedItems.push(removedItem);
      }
      return {
        ...state,
        rowdata: {
          ...state.rowdata,
          items: items.length
            ? items
            : [{ cashpayment_account: "", amount: "", reference: "", remarks: "", vehicle_no: "", ref_post_doc_no: "", qty: 0, vehicle_number: "" }],
          deletedItems,
        },
      };
    },
    isModelVisible: (state, action) => {
      if (!action.payload) {
        return {
          ...state,
          model: action.payload,
          rowdata: {
            items: [
              { cashpayment_account: "", amount: "", reference: "", remarks: "", vehicle_no: "", ref_post_doc_no: "", qty: 0, vehicle_number: "" },
            ],
            deletedItems: [],
          },
        };
      } else {
        return { ...state, model: action.payload };
      }
    },
    SetParams: (state, action) => {
      return { ...state, params: action.payload };
    },
    isDrawerVisible: (state, action) => {
      return { ...state, drawer: action.payload };
    },
    FilterInputChangeValue: (state, action) => {
      return {
        ...state,
        params: {
          ...state.params,
          [action.payload.key]: action.payload.value,
        },
      };
    },
    apiError: (state, action) => {
      return { ...state, loading: false, error_msg: action.payload };
    },
  },
});

export const {
  getCashPayments,
  cashPaymentListSuccessful,
  cashPaymentAdd,
  cashPaymentAddSuccessful,
  getCashPaymentById,
  cashPaymentByIdSuccessful,
  cashPaymentEdit,
  cashPaymentDelete,
  InputChangeValue,
  ItemInputChangeValue,
  addItemRow,
  removeItemRow,
  apiError,
  isModelVisible,
  SetParams,
  isDrawerVisible,
  FilterInputChangeValue,
} = cashPaymentSlice.actions;

export default cashPaymentSlice.reducer;
